export const moneyStringToNumber = (amount: string | number) => {
  const conversion = Number(
    typeof amount === "string" ? amount.replace(/[$,]/g, "") : amount
  );

  return isNaN(conversion) ? 0 : conversion;
};

export const toCents = (amount: string | number) => {
  return Math.round(moneyStringToNumber(amount) * 100);
};
